import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import UtuLanding from "@/pages/UtuLanding";
import Dashboard from "@/pages/Dashboard";
import CustomAIModels from "@/pages/CustomAIModels";
import CustomSoftware from "@/pages/CustomSoftware";
import ResearchRnd from "@/pages/ResearchRnd";
import EngageTiers from "@/pages/EngageTiers";
import McpPlayground from "@/pages/McpPlayground";
import McpDocs from "@/pages/McpDocs";
import Insights from "@/pages/Insights";
import About from "@/pages/About";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
        <div className="min-h-screen overflow-x-hidden">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<UtuLanding />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/services/custom-ai-models" element={<CustomAIModels />} />
              <Route path="/services/custom-software" element={<CustomSoftware />} />
              <Route path="/services/research-rnd" element={<ResearchRnd />} />
              <Route path="/engage/tiers" element={<EngageTiers />} />
              <Route path="/mcp/playground" element={<McpPlayground />} />
              <Route path="/mcp/docs" element={<McpDocs />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/about" element={<About />} />
            </Routes>
          </BrowserRouter>
          <Toaster />
        </div>
      </ThemeProvider>
    </HelmetProvider>
  );
}


export default App;
